/**
 * Imports
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "jquery/src/jquery.js";
import "popper.js/dist/popper.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/css/fontawesome/css/fontawesome5.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/styles.css";
import VModal from "vue-js-modal";
import VueI18n from 'vue-i18n';
import en from "./assets/Locale/en.json";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "./axios";
import VueAxios from "vue-axios";
import Toaster from "v-toaster";
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import "v-toaster/dist/v-toaster.css";
import Toasted from "vue-toasted";
import vSelect from "vue-select";
import VueProgressBar from 'vue-progressbar';
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueTelInput from 'vue-tel-input';
import InfiniteLoading from 'vue-infinite-loading';
import VTooltip from "v-tooltip";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "./common.js";
// import firebase from 'firebase/app';
// import 'firebase/messaging';
/**
 * Options
 */
let options = {
    iconPack: "fontawesome",
    fitToScreen: true,
    position: "top-center",
    duration: 3000,
    keepOnHover: true,
    singleton: true,
    closeOnSwipe: true,
    fullWidth: false,
    dismissable: true,
    action: {
      icon: "times",
      class: "action-class",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
};
const DEFAULT_OPTION = {
    canSuccess: true,
    show: false,
    color: '#f5a621',
    position: 'fixed',
    failedColor: 'red',
    thickness: '2px',
    transition: {
        speed: '0.1s',
        opacity: '0.6s',
    },
    autoRevert: true,
    location: 'top',
    inverse: false,
    autoFinish: false
}
const sweet_options = {
    customClass: {
      container: "container-class",
      popup: "popup-class",
      header: "header-class",
      title: "title-class",
      closeButton: "close-button-class",
      icon: "icon-class",
      image: "image-class",
      content: "content-class",
      input: "input-class",
      actions: "actions-class",
      confirmButton: "confirm-button-class",
      cancelButton: "cancel-button-class",
      footer: "footer-class",
    },
};
// const firebaseConfig = {
//   apiKey: "AIzaSyCjcUVMdUqmAWy0Q-h6ec2TPNv188NQ9h4",
//   authDomain: "pied-parker-a77a8.firebaseapp.com",
//   databaseURL: "https://pied-parker-a77a8.firebaseio.com",
//   projectId: "pied-parker-a77a8",
//   storageBucket: "pied-parker-a77a8.appspot.com",
//   messagingSenderId: "501159725010",
//   appId: "1:501159725010:web:1872d3d44081934cc9aa0b",
//   measurementId: "G-GV07TQF7NN"
// }
/**
 * Uses
 */
Vue.use(VModal);
Vue.use(VueI18n);
Vue.component("GmapCluster", GmapCluster);
Vue.use(VueAxios, axios);
Vue.use(Toaster, { timeout: 3000 });
Vue.component("v-select", vSelect);
Vue.use(Toasted, options);
Vue.use(VueProgressBar, DEFAULT_OPTION);
Vue.use(VueSweetalert2, sweet_options);
Vue.use(VueMoment, { moment, });
Vue.use(VueTelInput);
Vue.use(InfiniteLoading, { /* options */ });
Vue.use(VueGoogleMaps, {
    load: {
      // Piedparker default key
      // key: "AIzaSyCjcUVMdUqmAWy0Q-h6ec2TPNv188NQ9h4",
      key: "AIzaSyBTeSQpeOJb1KVmT8Dp0lmUnQ3ZAvvO6xI",
      libraries: "places", // This is required if you use the Autocomplete plugin
      // OR: libraries: 'places,drawing'
      // OR: libraries: 'places,drawing,visualization'
      // (as you require)
  
      // If you want to set the version, you can do so:
      // v: '3.26',
    },
  
    // If you intend to programmatically custom event listener code
    // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    // you might need to turn this on.
    // autobindAllEvents: false,
  
    // If you want to manually install components, e.g.
    // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    // Vue.component('GmapMarker', GmapMarker)
    // then set installComponents to 'false'.
    // If you want to automatically install all the components this property must be set to 'true':
    installComponents: true,
});
Vue.use(VTooltip);
Vue.component("multiselect", Multiselect);
// window.firebase = firebase.initializeApp(firebaseConfig);
// Vue time formatter filter
Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("LL");
  }
});
Vue.filter("formatDateTime", function(value) {
  if(value) {
    return moment(String(value)).format("lll");
  }
});

const i18n = new VueI18n({    
    locale: 'en', // set locale    
    fallbackLocale: 'en', // set fallback locale    
    messages:{
      en:en
  
    } // set locale messages
});

export const bus = new Vue();


Vue.config.productionTip = false;
window.EventBus = new Vue();
window.hostname = "https://backend.pied.cloud/"; //host name
window.featureFlags = window.featureFlags || {};
window.featureFlags.permitSwitchingAllowRefreshStripeMetadata = false;
window.awsURL='https://vwzyaqnokd.execute-api.us-west-2.amazonaws.com/prod?bucket=pied-production&file=';
window.awsURLNew ='https://vwzyaqnokd.execute-api.us-west-2.amazonaws.com/prod?bucket=pied-cameras-prod-us-west-1&file=';
window.supportPortal = 'https://support.klizos.com/';
window.vapidKey = "BEny6izku-1Pd93943pJ7pWPT_HnCW-M71G3WYQrJYYeh3ajIqDKtLkQDItk0oe6GqaHIcbvS5PQnI1095rUn2A";
//========== api header ========//
// axios.defaults.headers.common["Accept"] = "application/json";
// axios.defaults.headers.common["Authorization"] ="Bearer" + localStorage.getItem("commercial_token_new");
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use(
  function(config) {
    if (config.url.indexOf(window.hostname) != -1) {
      config.headers.Authorization =
        "Bearer " + localStorage.getItem("commercial_token_new");
      config.headers.accept = "application/json";
    } else if (
      config.url.indexOf(window.supportPortal) != -1 &&
      config.url.indexOf("/commercial/login") == -1
    ) {
      config.headers.Authorization = "Bearer " + localStorage.getItem("su_id");
      config.headers.accept = "application/json";
    }
    return config;
  },
  function(error) {
    console.log(error);
  }
);
axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if(axios.isCancel(error))
      {
        return Promise.reject(error);
      }
      const canAccessOperatorDashboard = () => {
        if (localStorage.getItem("role") !== 'operator') {
            return true;
        }

        try {
          const access_list = JSON.parse(localStorage.getItem("commercial_access_list") || '{}');
          const access_list_allowed = [            
            'report_access',
            // 'validation_access',
            'invitation_access',
            'permit_access',
          ]  
          for (const [key, value] of Object.entries(access_list)) {
            if (!value) {
              continue;
            }
            
            for (const allowed of access_list_allowed) {
              if (key.startsWith(allowed)) {
                return true;
              }
            }
          }
        } catch (e) {
          console.error(e);
        }
        
        return false;
      }
      // handle error
      if (
        (canAccessOperatorDashboard() === false || error.response.status === 401) &&
        error.config.url.indexOf("/api/commercial/login") === -1 &&
        error.config.url.indexOf(window.supportPortal) === -1
      ) {
        // alert(location.origin);
        console.debug("Logging out due to error", { error });
        localStorage.removeItem("commercial_token_new");
        router.push({path : '/login'});
        // location.replace(location.origin + "/login");
        // Vue.toasted.show(error.response.data.message,{
        //   icon : 'check-cirlce',
        //   iconPack: "fontawesome",
        //   className : 'success-class'
        // });
      }
      throw error;
    }
);

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
